import genericHelpers from '../../_utils/generic-helpers';

$(window).on('scroll', genericHelpers.debounce(() => {
  if ($(document).scrollTop()) {
    $('html').addClass('scrolled');
  } else {
    $('html').removeClass('scrolled');
  }
}, 100));
